<template>
  <div :style="{ position: 'relative', height: height, width: '100%' }">
    <Radar
      :chart-options="chartOptions"
      :chart-data="chartData"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :styles="styles"
      :width="width"
      :height="heightNum"
    />
  </div>
</template>

<script>
import { Radar } from 'vue-chartjs/legacy';

import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

export default {
    name: 'SacRadarChart',
    components: { Radar },
    props: {
        data: { type: Object, required: true },
        height: { type: String, default: '320px' },
        forceMax: { type: Number, default: null },
    },
    data() {
        return {
            chartId: 'sac-radar-chart',
            datasetIdKey: 'label',
            width: 400,
            cssClasses: '',
            styles: {},
            plugins: [],
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    r: {
                        angleLines: { color: 'rgba(0,0,0,0.08)' },
                        grid: { color: 'rgba(0,0,0,0.08)' },
                        suggestedMin: 0,
                        ticks: { backdropColor: 'transparent' },
                    },
                },
                plugins: { legend: { display: false } },
            },
        };
    },
    computed: {
        chartData() {
            return this.data || { labels: [], datasets: [] };
        },
        heightNum() {
            return parseInt(this.height, 10) || 320;
        },
        computedMax() {
            if (this.forceMax != null) return this.forceMax;
            const ds = (this.data && this.data.datasets) || [];
            let max = 0;
            for (const d of ds) {
                for (const v of (d.data || [])) {
                    const n = Number(v);
                    if (!isNaN(n) && n > max) max = n;
                }
            }
            if (max <= 0) return 10;
            return Math.ceil(max * 1.1);
        },
    },
    watch: {
        computedMax: {
            immediate: true,
            handler(val) {
                this.chartOptions = {
                    ...this.chartOptions,
                    scales: {
                        ...this.chartOptions.scales,
                        r: {
                            ...this.chartOptions.scales.r,
                            suggestedMax: val,
                        },
                    },
                };
            },
        },
    },
};
</script>
